module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABoAAAAaCAYAAACpSkzOAAAAvElEQVRIS+2VwQ3CMAxFX8UOLMEiHNmDE7PAMJyYC05FRlBFTVI7jumpuTvPP/9JGYg749JVQxyH1UHz5T8L/CPRBqpqslh6oQ53R6uDrCJ1J9pA3XbV5Pg9rdqR1a4wkKX0A/AA9sn7NCfSQCnkDhy/sFDQHHICntGgEuQF07+UJbKWnupZg5QUnqxrBbVABJyBtNJlqBXiBt2AMyB2SfHSiXZciXbABbgaIe5E2vZdMnguz2ZEAM26ENAbDehKAUl47ewAAAAASUVORK5CYII="


//////////////////
// WEBPACK FOOTER
// ./static/images/shopDetail/icon2.png
// module id = pdYw
// module chunks = 1